import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ef87a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "top" }
const _hoisted_2 = {
  key: 0,
  id: "loading-test-container",
  class: "overlay"
}
const _hoisted_3 = {
  key: 1,
  id: "proctor-pause-container",
  class: "overlay"
}
const _hoisted_4 = {
  key: 2,
  id: "section-pause-container",
  class: "overlay"
}
const _hoisted_5 = {
  key: 3,
  id: "tester-pause-container",
  class: "overlay"
}
const _hoisted_6 = {
  key: 4,
  id: "persistence-notification-container",
  class: "overlay overlay-transparent"
}
const _hoisted_7 = {
  key: 5,
  id: "network-error-container",
  class: "overlay"
}
const _hoisted_8 = {
  key: 6,
  id: "application-error-container",
  class: "overlay"
}
const _hoisted_9 = {
  key: 7,
  class: "player-container"
}
const _hoisted_10 = {
  key: 0,
  class: "loading"
}
const _hoisted_11 = { id: "test-review-container" }
const _hoisted_12 = {
  id: "item-container-wrapper",
  style: {"width":"98%","min-width":"400px","max-width":"1400px"}
}
const _hoisted_13 = ["hidden", "title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "focus-mode-button-icon",
  class: "fa fa-expand"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "navigation-footer-container" }, null, -1))
const _hoisted_17 = {
  id: "vertical-toolbar-container",
  class: "regular-toolbar-position"
}
const _hoisted_18 = {
  key: 8,
  class: "overlay"
}
const _hoisted_19 = { class: "review-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestStartController = _resolveComponent("TestStartController")!
  const _component_PauseView = _resolveComponent("PauseView")!
  const _component_PersistenceNotification = _resolveComponent("PersistenceNotification")!
  const _component_ApplicationErrorNotification = _resolveComponent("ApplicationErrorNotification")!
  const _component_FocusModeNavigationControl = _resolveComponent("FocusModeNavigationControl")!
  const _component_PlayerHeader = _resolveComponent("PlayerHeader")!
  const _component_InformationHeader = _resolveComponent("InformationHeader")!
  const _component_PnpToolContainer = _resolveComponent("PnpToolContainer")!
  const _component_TestReview = _resolveComponent("TestReview")!
  const _component_ItemToolbar = _resolveComponent("ItemToolbar")!
  const _component_ItemContainer = _resolveComponent("ItemContainer")!
  const _component_PnpExpandingToolbar = _resolveComponent("PnpExpandingToolbar")!
  const _component_ReviewScreen = _resolveComponent("ReviewScreen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingTest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TestStartController, {
            id: "test-start-controller",
            ref: "testStartController",
            onTestReady: _ctx.handleTestReady
          }, null, 8, ["onTestReady"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayProctorPaused)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_PauseView, {
            class: "pause-view-component",
            title: _ctx.$t('status.paused'),
            message: _ctx.$t('status.please_wait')
          }, null, 8, ["title", "message"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.displaySectionPaused)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_PauseView, {
            class: "pause-view-component",
            title: _ctx.$t('status.complete'),
            message: _ctx.$t('status.please_wait'),
            "wait-for-proctor-to-continue": true
          }, null, 8, ["title", "message"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayTesterPaused)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_PauseView, {
            class: "pause-view-component",
            title: _ctx.$t('status.paused'),
            message: _ctx.$t('status.paused_info'),
            "show-review-button": true
          }, null, 8, ["title", "message"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.persistenceNetworkStatus === _ctx.persistenceSaving || _ctx.persistenceNetworkStatus === _ctx.persistenceUnrecoverableError
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_PersistenceNotification, {
            class: "persistence-notification",
            "persistence-status": _ctx.persistenceNetworkStatus,
            onExitTestClicked: _ctx.handleExitTest
          }, null, 8, ["persistence-status", "onExitTestClicked"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.networkError === _ctx.persistenceUnrecoverableNetworkError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_PersistenceNotification, {
            class: "persistence-notification",
            "persistence-status": _ctx.persistenceUnrecoverableNetworkError,
            onExitTestClicked: _ctx.handleExitTest
          }, null, 8, ["persistence-status", "onExitTestClicked"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.applicationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ApplicationErrorNotification, {
            class: "persistence-notification",
            onExitTestClicked: _ctx.handleExitTest
          }, null, 8, ["onExitTestClicked"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showContainer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "content",
            ref: "content",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideReviewClick && _ctx.handleOutsideReviewClick(...args)))
          }, [
            _createVNode(_Transition, { name: "focus-mode-navigation-control-transition" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_FocusModeNavigationControl, { id: "focus-mode-navigation-control" }, null, 512), [
                  [_vShow, _ctx.focusMode]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_PlayerHeader, {
              "title-delivery-option": _ctx.titleDeliveryOption,
              width: "97%",
              "max-width": "1400px",
              "timer-delivery-option": _ctx.timerDeliveryOption,
              "pause-button-option": _ctx.pauseButtonDeliveryOption,
              "exit-button-option": _ctx.exitButtonDeliveryOption,
              "preview-mode": _ctx.isPreviewMode,
              "display-name-delivery-option": _ctx.displayNameDeliveryOption,
              "preview-mode-text": _ctx.previewModeText,
              "pause-test": _ctx.pauseTest
            }, null, 8, ["title-delivery-option", "timer-delivery-option", "pause-button-option", "exit-button-option", "preview-mode", "display-name-delivery-option", "preview-mode-text", "pause-test"]), [
              [_vShow, !_ctx.focusMode_]
            ]),
            _withDirectives(_createVNode(_component_InformationHeader, {
              ref: "informationBanner",
              item: _ctx.currentItem,
              width: "97%",
              "max-width": "1400px",
              "progress-bar-delivery-option": _ctx.progressBarDeliveryOption,
              "show-review-progress-button": _ctx.showReviewProgressButton(),
              "test-controller": _ctx.testController,
              "show-item-progress": _ctx.showItemProgress()
            }, null, 8, ["item", "progress-bar-delivery-option", "show-review-progress-button", "test-controller", "show-item-progress"]), [
              [_vShow, !_ctx.focusMode_]
            ]),
            _createVNode(_component_PnpToolContainer, { id: "tool-container" }),
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.showReviewScreen)
                ? (_openBlock(), _createBlock(_component_TestReview, {
                    key: 0,
                    ref: "testReview",
                    "test-part": _ctx.testController.test.testParts[0],
                    "display-items": _ctx.testController.navigationController.getDisplayItems(),
                    "navigation-controller": _ctx.testController?.navigationController,
                    "section-lock-enabled": _ctx.sectionLockEnabled(),
                    "is-test-end-review": "false",
                    "flag-item-enabled": _ctx.flagItemEnabled()
                  }, null, 8, ["test-part", "display-items", "navigation-controller", "section-lock-enabled", "flag-item-enabled"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                id: "focus-mode-button",
                hidden: !_ctx.focusModeEnabled,
                title: _ctx.$t('toolbar.enter_focus_mode'),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focusModeClicked && _ctx.focusModeClicked(...args)))
              }, _hoisted_15, 8, _hoisted_13),
              (_ctx.showItemToolbar())
                ? (_openBlock(), _createBlock(_component_ItemToolbar, {
                    key: 0,
                    id: "item-toolbar-container",
                    ref: "itemToolbar",
                    "delivery-options": _ctx.getItemDeliveryOptions()
                  }, null, 8, ["delivery-options"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ItemContainer, {
                id: "item-container",
                ref: "itemContainer",
                item: _ctx.currentItem,
                "test-controller": _ctx.testController,
                "show-question-number": _ctx.showQuestionNumber(),
                onHeightChange: _ctx.handleItemContainerHeightChange,
                onReady: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showItemToolbar()))
              }, null, 8, ["item", "test-controller", "show-question-number", "onHeightChange"])
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_PnpExpandingToolbar, {
                test: _ctx.testController?.test,
                "focus-mode": _ctx.focusMode
              }, null, 8, ["test", "focus-mode"])
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showReviewScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_ReviewScreen, { "test-controller": _ctx.testController }, null, 8, ["test-controller"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}